import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IRefinementGroup, IRefinement } from 'models/filtering/refinement';
import { ProductRefinementGroupings } from 'models/enums/productRefinement';
import { getRefinementGroupTranslationKey } from 'helpers/common';

require('./style.css');

interface IProps {
	refinementGroup?: IRefinementGroup;
	onRefinementClick?: (groupId: number, refinementId: number) => void;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class FilterGroup extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.handleOnRefinementClick = this.handleOnRefinementClick.bind(this);
	}

	private handleOnRefinementClick(e: React.SyntheticEvent, groupId: number, refinementId: number) {
		if (e) {
			e.preventDefault();
		}
		if (this.props.onRefinementClick) {
			this.props.onRefinementClick(groupId, refinementId);
		}
	}

	//TODO: remove this, only temporary helper
	private getCssStatus(refinement: IRefinement) {
		if (refinement.available) {
			return 'availableItem';
		} else if (refinement.selected && refinement.disabled) {
			return 'selecteddisabledItem';
		} else if (refinement.disabled) {
			return 'disabledItem';
		} else if (refinement.selected) {
			return 'selectedItem';
		}
	}

	private getRefinementGroupClassName(refinementGroup: ProductRefinementGroupings, prefix: string) {
		let filterClass = '';
		switch (refinementGroup) {
			case ProductRefinementGroupings.Brand:
				filterClass = prefix + 'brand';
				break;
			case ProductRefinementGroupings.Color:
				filterClass = prefix + 'color';
				break;
			case ProductRefinementGroupings.Material:
				filterClass = prefix + 'material';
				break;
			case ProductRefinementGroupings.Print:
				filterClass = prefix + 'print';
				break;
			case ProductRefinementGroupings.Size:
				filterClass = prefix + 'size';
				break;
			default:
				filterClass = '';
		}
		return filterClass;
	}

	private getRefinementAttributes(groupId: ProductRefinementGroupings, refinements: IRefinement[]): JSX.Element[] {
		return refinements.map((refinement: IRefinement, index: number) => {
			const translationString = getRefinementGroupTranslationKey(groupId);
			const groupClass = this.getRefinementGroupClassName(groupId, '');
			let title = this.props.t(translationString + refinement.id);
			if (groupId === ProductRefinementGroupings.Color) {
				title = '';
			}
			return (
				<li key={'refinement_Item_' + groupId + '_' + index} className={`refinementItem ${groupClass + refinement.id}`}>
					<a
						className={this.getCssStatus(refinement)}
						href="#"
						onClick={(e) => this.handleOnRefinementClick(e, groupId, refinement.id)}
					>
						{title}
					</a>
				</li>
			);
		});
	}

	public render() {
		const { refinementGroup } = this.props;

		const groupClass = this.getRefinementGroupClassName(refinementGroup.groupId, 'filter');

		return (
			<div className={`filterGroupWrapper ${groupClass}`}>
				<div className="filterGroupBox">
					<ul className="filterAttributes">
						{this.getRefinementAttributes(refinementGroup.groupId, refinementGroup.refinements)}
					</ul>
				</div>
			</div>
		);
	}
}

export { FilterGroup };
